import { call } from "../clients/internalClient";
import { ReportError } from "../utils/errorReport/errorReportAPI";
import { BlockUI, UnBlockUI } from "../utils/uiBlock/uiBlockAPI";


export async function redirectToStripePortal() {

  const blockToken = BlockUI('Redirecting to the customer payment and subscription portal...')
  try {

    const data = await call('POST', '/api/stripe-portal', {
      returnUrl: window.location.href
    });

    window.location.href = data.portalUrl

  } catch (err) {
    ReportError(
      err.statusCode === 404 
      ? 'You are not enrolled yet, please click to subscribe' 
      : 'Error navigating to the customer payment and subscription portal'
    );
    console.error(err);
    UnBlockUI(blockToken)
  } finally {
    // keep blocking until we navigate
  }

}

export async function checkout(mode: string) {
  const blockToken = BlockUI('Redirecting to the customer payment portal...')
  try {
    const data = await call('POST', '/api/create-checkout-session', {
      callbackUrl: window.location.href,
      count: 1,
      mode: mode || 'credits'
    });

    if (data.url) {
      window.location.href = data.url; // Redirect to Stripe Checkout or similar
    } else {
      alert('No redirect URL returned.');
    }
  } catch (err) {    
    console.error('Checkout error:', err);
    ReportError(
      err.statusCode === 409 ? 
        'Already subscribed, please navigate to your subscription portal to manage your subscriptions.' :
        'Something went wrong during checkout.'
    );
    UnBlockUI(blockToken)
  } finally {
    // keep blocking until we navigate
  }
};
